module.exports = __webpack_public_path__ + "img/hip_roof_one.9d71b602.png";